class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-predictive-search-input]');
    this.clearBtn = this.querySelector('[data-predictive-search-clear]');
    this.resultsContainer = this.querySelector('[data-predictive-search-results]');
    this.defaultContent = this.querySelector('[data-predictive-search-default]');
    this.apiContent = this.querySelector('[data-predictive-search-api]');
    this.hint = this.querySelector('[data-predictive-search-hint]');
    this.apiUrl = this.dataset.predictiveSearchUrl;
    this.debounceTimer = null;
    this.debounceMs = 300;
  }

  connectedCallback() {
    if (!this.input || !this.resultsContainer || !this.apiUrl) return;

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.input.addEventListener('blur', this.onBlur.bind(this));
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeydown.bind(this));

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', this.onClear.bind(this));
    }

    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onDocumentKeydown.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick.bind(this));
    document.removeEventListener('keydown', this.onDocumentKeydown.bind(this));
  }

  onFocus() {
    this.open();
  }

  onBlur() {
    // Delay to allow click on results
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    }, 150);
  }

  onInput() {
    const value = this.input.value.trim();
    this.toggleClearButton(value.length > 0);

    if (value.length === 0) {
      this.showDefault();
      return;
    }

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => this.fetchResults(value), this.debounceMs);
  }

  onClear() {
    this.input.value = '';
    this.input.focus();
    this.toggleClearButton(false);
    this.showDefault();
    this.open();
  }

  onKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  onDocumentClick(e) {
    if (!this.contains(e.target)) {
      this.close();
    }
  }

  onDocumentKeydown(e) {
    if (e.key === 'Escape') {
      this.close();
    }
  }

  open() {
    this.resultsContainer.hidden = false;
    this.input.setAttribute('aria-expanded', 'true');
    if (this.hint) this.hint.hidden = false;
  }

  close() {
    this.resultsContainer.hidden = true;
    this.input.setAttribute('aria-expanded', 'false');
    if (this.hint) this.hint.hidden = true;
  }

  toggleClearButton(show) {
    if (this.clearBtn) {
      this.clearBtn.hidden = !show;
    }
  }

  showDefault() {
    this.defaultContent.hidden = false;
    this.apiContent.hidden = true;
    this.apiContent.innerHTML = '';
  }

  showApiResults(html) {
    this.defaultContent.hidden = true;
    this.apiContent.hidden = false;
    this.apiContent.innerHTML = html;
  }

  async fetchResults(term) {
    const url = `${this.apiUrl}?q=${encodeURIComponent(term)}&section_id=predictive-search`;
    try {
      const response = await fetch(url);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const section = doc.getElementById('shopify-section-predictive-search');
      if (section) {
        this.showApiResults(section.innerHTML);
      } else {
        this.showDefault();
      }
    } catch {
      this.showDefault();
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
